import { useApp } from "./context";
import { MainLayout } from "./features/main/MainLayout";
import { Onboarding } from "./features/onboarding/Onboarding";
import { Toast } from "./features/main/Toast";

export function App() {
  const app = useApp();
  return (
    <>
      {app.route === "onboarding" ? <Onboarding mode="firstRun" /> : <MainLayout />}
      <Toast />
    </>
  );
}
